import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { dashboardTheme } from './presentation/theme/dashboardTheme';
import { AuthProvider } from './presentation/contexts/AuthContext';
import { NavigationProvider } from './presentation/components/Navigation/NavigationContext';
import { useAuth } from './hooks/useAuth';

// Pages
import LoginPage from './presentation/pages/LoginPage';
import DashboardLayout from './presentation/layout/DashboardLayout';
import { MyShiftPage } from './presentation/pages/MyShift';
import LoadingScreen from './presentation/components/LoadingScreen';

// Protected Route Component
interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// App Routes Component (AuthProvider内で使用)
const AppRoutes: React.FC = () => {
  return (
    <NavigationProvider>
      <Routes>
        {/* 公開ルート */}
        <Route path="/login" element={<LoginPage />} />

        {/* 保護されたルート */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/my-shift" replace />} />
          <Route path="my-shift" element={<MyShiftPage />} />
        </Route>

        {/* 404ページ */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </NavigationProvider>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={dashboardTheme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
